import { FC, PropsWithChildren } from 'react';
import Head from 'next/head';

interface IThemeHeaderProps {
  color?: string;
}

export const ThemeHeader: FC<PropsWithChildren<IThemeHeaderProps>> = ({
  color = '#fff',
}) => {
  return (
    <Head>
      <meta content={color} name="theme-color" />
      <meta content={color} name="msapplication-TileColor" />
    </Head>
  );
};
